// @flow

import linkify from 'linkify-it';


let instance;
export default (): any => instance || (instance = linkify());
